module.exports = __webpack_public_path__ + "img/edit.3f7df07f.svg";